module.exports = __webpack_public_path__ + "static/5invgde-33a42da2351ca7eb7284d8f94f4bb4c5.gif";